import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import ContratCDITempsPlein from "./ContratType/CDITempsPlein";
import ContratCDITempsPartiel from "./ContratType/CDITempsPartiel";
import ContratCDITempsPleinBTP from "./ContratType/CDITempsPleinBTP";
import ContratCDITempsPartielBTP from "./ContratType/CDITempsPartielBTP";
import ContratCDDTempsPlein from "./ContratType/CDDTempsPlein";
import ContratCDDTempsPartiel from "./ContratType/CDDTempsPartiel";
import ContratCDDTempsPleinBTP from "./ContratType/CDDTempsPleinBTP";
import ContratCDDTempsPartielBTP from "./ContratType/CDDTempsPartielBTP";
import { getInitialFormData, initialiserArticlesTexte } from "./FormUtils";

import { dialog } from "../../components/ui/Dialog";
export default function Contrat() {
  const [typeFormulaire, setTypeFormulaire] = useState("cdi_plein");
  const [contratType, setContratType] = useState("cdi");
  const [specType, setSpecType] = useState("plein");
  const [ajustementBTP, setAjustementBTP] = useState(false);

  const [shownTextareas, setShownTextareas] = useState({});

  const toggleTextarea = (key) => {
    setShownTextareas((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const [formData, setFormData] = useState(() =>
    getInitialFormData("Monsieur", "", "")
  );

  const articlesParType = useMemo(
    () => ({
      cdi_plein: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: false,
        article6: true,
        article7: false,
        article8: true,
        article9: true,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdi_partiel: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: false,
        article6: true,
        article7: false,
        article8: true,
        article9: true,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdi_plein_btp: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: false,
        article6: true,
        article7: false,
        article8: true,
        article9: true,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdi_partiel_btp: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: false,
        article6: true,
        article7: false,
        article8: true,
        article9: true,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdd_plein: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: true,
        article6: false,
        article7: false,
        article8: true,
        article9: false,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdd_partiel: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: true,
        article6: false,
        article7: false,
        article8: true,
        article9: false,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdd_plein_btp: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: true,
        article6: false,
        article7: false,
        article8: true,
        article9: false,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
      cdd_partiel_btp: {
        article1: false,
        article2: true,
        article3: true,
        article4: false,
        article5: true,
        article6: false,
        article7: false,
        article8: true,
        article9: false,
        article10: false,
        article11: true,
        article12: true,
        article13: true,
        article14: false,
        article15: true,
        article16: true,
        article17: true,
        article18: false,
        article19: false,
        article20: true,
        article21: false,
        article22: false,
        article23: false,
        article24: false,
        article25: true,
        article26: false,
        article27: false,
        article28: true,
      },
    }),
    []
  );

  const [include, setInclude] = useState(articlesParType[typeFormulaire]);
  const handleContratTypeChange = (e) => {
    const { value } = e.target;
    setContratType(value);
  };

  const handleSpecTypeChange = (e) => {
    const { value } = e.target;
    setSpecType(value);
  };

  const handleBTPChange = (e) => {
    setAjustementBTP(e.target.checked);
  };

  // Calcul automatique de typeFormulaire
  useEffect(() => {
    if (!contratType || !specType) return;

    let newType = "";
    if (contratType === "cdi") {
      if (specType === "plein") {
        newType = ajustementBTP ? "cdi_plein_btp" : "cdi_plein";
      } else if (specType === "partiel") {
        newType = ajustementBTP ? "cdi_partiel_btp" : "cdi_partiel";
      }
    } else if (contratType === "cdd") {
      if (specType === "plein") {
        newType = ajustementBTP ? "cdd_plein_btp" : "cdd_plein";
      } else if (specType === "partiel") {
        newType = ajustementBTP ? "cdd_partiel_btp" : "cdd_partiel";
      }
    }
    setTypeFormulaire(newType);
  }, [contratType, specType, ajustementBTP]);

  useEffect(() => {
    if (articlesParType[typeFormulaire]) {
      setInclude(articlesParType[typeFormulaire]);
    }
  }, [typeFormulaire, articlesParType]);

  function calculerDureeCDD(debut, fin) {
    if (!debut || !fin) return "";

    const dateDebut = new Date(debut);
    const dateFin = new Date(fin);

    if (isNaN(dateDebut) || isNaN(dateFin) || dateFin < dateDebut) return "";

    // Ajouter 1 jour à la date de fin pour inclure le jour de début
    const dateFinAjustee = new Date(dateFin);
    dateFinAjustee.setDate(dateFinAjustee.getDate() + 1);

    let annees = dateFinAjustee.getFullYear() - dateDebut.getFullYear();
    let mois = dateFinAjustee.getMonth() - dateDebut.getMonth();
    let jours = dateFinAjustee.getDate() - dateDebut.getDate();

    if (jours < 0) {
      mois -= 1;
      const dernierJourMois = new Date(
        dateFinAjustee.getFullYear(),
        dateFinAjustee.getMonth(),
        0
      ).getDate();
      jours += dernierJourMois;
    }

    if (mois < 0) {
      annees -= 1;
      mois += 12;
    }

    let texte = "";
    if (annees > 0) texte += `${annees} an${annees > 1 ? "s" : ""}`;
    if (mois > 0) texte += `${texte ? " et " : ""}${mois} mois`;
    if (jours > 0)
      texte += `${texte ? " et " : ""}${jours} jour${jours > 1 ? "s" : ""}`;

    return texte || "0 jour";
  }

  function ajouterMois(dateStr, nbMois) {
    if (!dateStr || !nbMois || isNaN(nbMois)) return "";

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return ""; // <- évite l'erreur "Invalid time value"

    date.setMonth(date.getMonth() + parseInt(nbMois, 10));

    return date.toISOString().split("T")[0]; // format YYYY-MM-DD
  }

  function ajouterJour(dateStr, nbJours) {
    if (!dateStr || isNaN(nbJours)) return "";

    // Prendre uniquement la partie date si dateStr contient heure (ex: "2023-06-18T10:00:00")
    const dateOnly = dateStr.split("T")[0];

    const date = new Date(dateOnly);
    if (isNaN(date.getTime())) return "";

    const jours = parseInt(nbJours, 10);
    if (isNaN(jours)) return "";

    // Ajoute les jours (peut être négatif)
    date.setDate(date.getDate() + jours);

    // Format YYYY-MM-DD (on force le padStart pour les mois et jours < 10)
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "civilite") {
      const mfValue = value === "Madame" ? "e " : "";
      const mf2Value = value === "Madame" ? "elle" : "il";
      setFormData((prev) => ({
        ...prev,
        civilite: value,
        mf: mfValue,
        mf2: mf2Value,
      }));
      return;
    }

    if (name === "securtie_sociale") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 15);
      const groups = [
        digitsOnly.slice(0, 1),
        digitsOnly.slice(1, 3),
        digitsOnly.slice(3, 5),
        digitsOnly.slice(5, 7),
        digitsOnly.slice(7, 10),
        digitsOnly.slice(10, 13),
        digitsOnly.slice(13, 15),
      ];
      const formatted = groups.filter(Boolean).join(" ");

      setFormData((prev) => ({
        ...prev,
        securtie_sociale: formatted,
      }));
      return;
    }

    const updatedForm = {
      ...formData,
      [name]: value,
    };

    if (name === "debut_cdd" || name === "fin_cdd") {
      updatedForm.duree_cdd = calculerDureeCDD(
        name === "debut_cdd" ? value : formData.debut_cdd,
        name === "fin_cdd" ? value : formData.fin_cdd
      );
    }

    if (name === "debut_cdd" || name === "durre_pressai_cdd") {
      const debutCdd = name === "debut_cdd" ? value : formData.debut_cdd;
      const dureePressaiCDD =
        name === "durre_pressai_cdd" ? value : formData.durre_pressai_cdd;

      updatedForm.date_fin_pressai = ajouterJour(debutCdd, dureePressaiCDD);
    } else if (name === "date_embauche" || name === "durre_pressai") {
      const dateEmbauche =
        name === "date_embauche" ? value : formData.date_embauche;
      const dureePressai =
        name === "durre_pressai" ? value : formData.durre_pressai;

      updatedForm.date_fin_pressai = ajouterMois(dateEmbauche, dureePressai);
    }

    setFormData(updatedForm);
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  function enToutesLettres(n) {
    const unités = [
      "",
      "un",
      "deux",
      "trois",
      "quatre",
      "cinq",
      "six",
      "sept",
      "huit",
      "neuf",
      "dix",
      "onze",
      "douze",
      "treize",
      "quatorze",
      "quinze",
      "seize",
    ];

    const dizaines = [
      "",
      "",
      "vingt",
      "trente",
      "quarante",
      "cinquante",
      "soixante",
      "soixante",
      "quatre-vingt",
      "quatre-vingt",
    ];

    if (n === 0) return "zéro";
    if (n < 17) return unités[n];
    if (n < 20) return "dix-" + unités[n - 10];
    if (n < 70) {
      let u = n % 10;
      let d = Math.floor(n / 10);
      return (
        dizaines[d] + (u === 1 && d !== 8 ? "-et-un" : u ? "-" + unités[u] : "")
      );
    }
    if (n < 80) {
      return "soixante-" + enToutesLettres(n - 60);
    }
    if (n < 100) {
      return "quatre-vingt" + (n === 80 ? "s" : "-" + enToutesLettres(n - 80));
    }
    if (n < 200) {
      return "cent" + (n > 100 ? " " + enToutesLettres(n - 100) : "");
    }
    if (n < 1000) {
      let c = Math.floor(n / 100);
      let reste = n % 100;
      return (
        unités[c] +
        " cent" +
        (reste ? " " + enToutesLettres(reste) : "") +
        (reste === 0 && c > 1 ? "s" : "")
      );
    }
    if (n < 2000) {
      return "mille" + (n > 1000 ? " " + enToutesLettres(n - 1000) : "");
    }
    if (n < 1000000) {
      let m = Math.floor(n / 1000);
      let reste = n % 1000;
      return (
        enToutesLettres(m) +
        " mille" +
        (reste ? " " + enToutesLettres(reste) : "")
      );
    }

    return "nombre trop grand";
  }

  function convertirMontantEnLettres(montantStr) {
    if (!montantStr) return "";

    const montant = montantStr.replace(",", ".").replace(/[^\d.]/g, "");
    const num = parseFloat(montant);

    if (isNaN(num)) return "";

    const euros = Math.floor(num);
    const centimes = Math.round((num - euros) * 100);

    let texte =
      enToutesLettres(euros).toUpperCase() + " EURO" + (euros > 1 ? "S" : "");

    if (centimes > 0) {
      texte +=
        " ET " +
        enToutesLettres(centimes).toUpperCase() +
        " CENTIME" +
        (centimes > 1 ? "S" : "");
    }

    return texte;
  }

  const renderForm = () => {
    switch (typeFormulaire) {
      case "cdi_plein":
        return (
          <ContratCDITempsPlein
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdi_partiel":
        return (
          <ContratCDITempsPartiel
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdi_plein_btp":
        return (
          <ContratCDITempsPleinBTP
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdi_partiel_btp":
        return (
          <ContratCDITempsPartielBTP
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdd_plein":
        return (
          <ContratCDDTempsPlein
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdd_partiel":
        return (
          <ContratCDDTempsPartiel
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdd_plein_btp":
        return (
          <ContratCDDTempsPleinBTP
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      case "cdd_partiel_btp":
        return (
          <ContratCDDTempsPartielBTP
            formData={formData}
            setFormData={setFormData}
            include={include}
            handleInputChange={handleInputChange}
            handleCheckbox={handleCheckbox}
            convertirMontantEnLettres={convertirMontantEnLettres}
            initialiserArticlesTexte={initialiserArticlesTexte}
            toggleTextarea={toggleTextarea}
            shownTextareas={shownTextareas}
          />
        );
      default:
        return null;
    }
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;

    setInclude((prev) => {
      let newInclude = { ...prev, [name]: checked };

      // Logique spécifique selon le type de contrat
      if (contratType === "cdi") {
        if (["article3", "article4", "article5"].includes(name)) {
          if (name === "article3" && checked) {
            newInclude.article4 = false;
            newInclude.article5 = false;
          } else if (name === "article4" && checked) {
            newInclude.article3 = false;
            newInclude.article5 = false;
          } else if (name === "article5" && checked) {
            newInclude.article3 = false;
            newInclude.article4 = false;
          } else if (
            (name === "article3" || name === "article4") &&
            !checked &&
            !(prev.article3 || prev.article4)
          ) {
            newInclude.article5 = true;
          }
        }
      } else if (contratType === "cdd") {
        if (["article3", "article4"].includes(name)) {
          if (name === "article3" && checked) {
            newInclude.article4 = false;
          } else if (name === "article4" && checked) {
            newInclude.article3 = false;
          } else if (!checked && !prev.article3 && !prev.article4) {
            // Si aucun n'est sélectionné, article3 est sélectionné par défaut
            newInclude.article3 = true;
          }
        }
      }

      return newInclude;
    });
  };

  const remplacerChampsManquants = (data) => {
    const result = {};
    Object.keys(data).forEach((key) => {
      const val = data[key];
      if (val === "" || val === null || val === undefined) {
        result[key] = "[MANQUANT]";
      } else if (
        typeof val === "object" &&
        val !== null &&
        !Array.isArray(val)
      ) {
        result[key] = remplacerChampsManquants(val); // récursif si objets imbriqués
      } else {
        result[key] = val;
      }
    });
    return result;
  };
  const generateContrat = async () => {
    try {
      const modeleParType = {
        cdi_plein: "/CDI_temps_plein.docx",
        cdi_partiel: "/CDI_temps_partiel.docx",
        cdi_plein_btp: "/CDI_temps_plein_BTP.docx",
        cdi_partiel_btp: "/CDI_temps_partiel_Btp.docx",
        cdd_plein: "/CDD_temps_plein.docx",
        cdd_partiel: "/CDD_temps_partiel.docx",
        cdd_plein_btp: "/CDD_temps_plein_BTP.docx",
        cdd_partiel_btp: "/CDD_temps_partiel_BTP.docx",
      };

      const res = await fetch(modeleParType[typeFormulaire]);
      if (!res.ok) throw new Error("Impossible de charger le modèle");
      const arrayBuffer = await res.arrayBuffer();
      const zip = new PizZip(arrayBuffer);

      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
        delimiters: { start: "<%", end: "%>" },
      });

      const articleTextes = initialiserArticlesTexte({
        ...formData,
      });

      const data = {
        ...formData,
        ...articleTextes,
        date_embauche: formatDate(formData.date_embauche),
        date_fin_pressai: formatDate(formData.date_fin_pressai),
        debut_cdd: formatDate(formData.debut_cdd),
        fin_cdd: formatDate(formData.fin_cdd),
        ...Object.keys(include).reduce((acc, key) => {
          acc[key] = include[key];
          return acc;
        }, {}),
      };

      let num = 1;
      Object.keys(include).forEach((key) => {
        data[`${key}_numero`] = include[key] ? num++ : "";
      });

      function nettoyerChamps(docData) {
        const result = {};
        for (const key in docData) {
          const value = docData[key];
          if (typeof value === "string") {
            if (value.trim() !== "") result[key] = value.trim();
          } else if (value !== undefined && value !== null) {
            result[key] = value;
          }
        }
        return result;
      }

      const finalData = nettoyerChamps(remplacerChampsManquants(data));
      doc.render(finalData);

      const blob = doc.getZip().generate({ type: "blob" });
      saveAs(blob, "Contrat_personnalise.docx");
    } catch (err) {
      console.error(err);
      dialog.alert("Erreur : " + err.message);
    }
  };

  return (
    <div>
      <p style={{ margin: 0, fontSize: "12px", marginBottom: "5px" }}>
        Acceuil &gt; Contrat
      </p>
      <div style={{ display: "flex", gap: "40px", marginBottom: "20px" }}>
        {/* Colonne de gauche - Type de contrat */}
        <div>
          <h4>Type de contrat</h4>
          <div>
            <label>
              <input
                type="checkbox"
                checked={contratType === "cdi"}
                onChange={handleContratTypeChange}
                value="cdi"
              />
              CDI
            </label>
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                checked={contratType === "cdd"}
                onChange={handleContratTypeChange}
                value="cdd"
              />
              CDD
            </label>
          </div>
        </div>

        {/* Colonne de droite - Spécificité + Ajustement */}
        <div>
          <h4>Spécificité</h4>
          <div>
            <label>
              <input
                type="checkbox"
                checked={specType === "plein"}
                onChange={handleSpecTypeChange}
                value="plein"
              />
              Temps plein
            </label>
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                checked={specType === "partiel"}
                onChange={handleSpecTypeChange}
                value="partiel"
              />
              Temps partiel
            </label>
          </div>
        </div>
        <div>
          <h4 style={{ marginTop: "20px" }}>Ajustement</h4>
          <label>
            <input
              type="checkbox"
              checked={ajustementBTP}
              onChange={handleBTPChange}
            />
            BTP
          </label>
        </div>
      </div>

      {renderForm()}
      <br />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "30px",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            width: "50%",
            backgroundColor: "#840040",
            color: "#fff",
            padding: "10px 30px",
            borderRadius: "5px",
            border: "none",
          }}
          onClick={generateContrat}
        >
          Générer le contrat
        </button>
      </div>

      <br />
      <br />
      <br />
    </div>
  );
}
